import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { BuyerListModel } from "../vo/buyer-model";


/**
 * 部門名商品担当者を取得するサービス
 *
 * @export GetClassBuyerIdService
 * @class GetClassBuyerIdService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetClassBuyerIdService extends PlessJsonResponderSub<BuyerListModel> {
  private classCode = '';
  private successFunc: (data: BuyerListModel) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetClassBuyerIdService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ClassCode: this.classCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetClassBuyerIdService
   */
  execute(classCode: string, successFunc: (data: BuyerListModel) => void): void {
    this.classCode = classCode;
    this.success = successFunc;
    this.send('getClassBuyerId', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetClassBuyerIdService
   */
  success(data: BuyerListModel): void {
    if (this.successFunc) {
      this.successFunc(data);
    }
  }
}